module.exports = __webpack_public_path__ + "img/banner_vivelatino.dee5c73d.png";